<template>
  <div>
      <label style="margin-left:25px;font-size:16px">ERP角色操作流程</label>
      <el-row>
          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/Boss%E8%B4%A6%E5%8F%B7%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  1.Boss账号操作流程.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E8%BF%90%E8%90%A5%E8%B4%A6%E6%88%B7%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  2.运营账户操作流程.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E9%87%87%E8%B4%AD%E5%B8%90%E6%88%B7%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  3.采购账户操作流程.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E8%B4%A2%E5%8A%A1%E8%B4%A6%E6%88%B7%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  4.财务账户操作流程.mp4 
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%BA%BA%E4%BA%8B%E5%B8%90%E6%88%B7%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  5.人事账户操作流程.mp4 
              </div>
          </el-card>
      </el-row>

      <label style="margin-left:25px;font-size:16px">采购异常件的处理流程</label>
      <el-row>
          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E9%83%A8%E5%88%86%E7%A0%B4%E6%8D%9F.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  1.异常件处理-部分破损.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E5%8D%95%E5%8F%B7%E6%9C%AA%E5%A1%AB%E5%86%99%E6%88%96%E5%8D%95%E5%8F%B7%E9%94%99%E8%AF%AF.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  2.异常件处理-单号未填写或单号错误.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E6%8B%A6%E6%88%AA.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  3.异常件处理-拦截.mp4
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E5%85%A8%E9%83%A8%E7%A0%B4%E6%8D%9F.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  4.异常件处理-全部破损.mp4 
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E5%9B%BE%E8%B4%A7%E4%B8%8D%E7%AC%A6%E5%92%8C%E7%BC%BA%E8%B4%A7.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  5.异常件处理-图货不符和缺货.mp4 
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E4%B8%80%E5%8D%95%E5%88%86%E5%8C%85%E5%8F%91%E8%B4%A7.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  6.异常件处理-一单分包发货.mp4 
              </div>
          </el-card>

          <el-card shadow="hover" class="video_lista">
              <div class="video_list_video">
                <video width="228" height="128" controls>
                    <source src="https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%BC%82%E5%B8%B8%E4%BB%B6%E5%A4%84%E7%90%86-%E4%B8%80%E7%A5%A8%E5%A4%9A%E4%BB%B6%E4%B8%AD%E5%87%BA%E7%8E%B0%E5%A4%9A%E8%B4%A7.mp4" type="video/mp4">
                </video>
              </div>
              <div class="video_list_title">
                  7.异常件处理-一票多件中出现多货.mp4 
              </div>
          </el-card>


      </el-row>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../api/api/api";
export default {
    name: "Teachingvideo",
    data() {
        return {
            
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
    },
    methods: {
      VideoList(){

      }
    }
}
</script>

<style>
.video_lista{
    width: 268px;
    min-height: 100px;
    float: left;
    margin: 25px;
}
.video_list_title {
    width: 100%;
    height: 30px;
    line-height: 40px;
    text-align: center;
    overflow: hidden;
}
.video_list_video {
    height: 130px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
</style>